var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":_vm.viewBox,"width":_vm.width + 'px',"height":_vm.height + 'px'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }